/* eslint-disable no-unused-vars */
import React from 'react'
import {Combobox} from '@fuegokit/react'
const StyledComboboxExample = () => {
  return (
    <>
      {/* <span>styled combobox example</span> */}
      <Combobox>
        <Combobox.Label>Favorite Animal</Combobox.Label>
        <div>
          <Combobox.Input />
          <Combobox.Button>▼</Combobox.Button>
        </div>
        <Combobox.Popover>
          <Combobox.Listbox>
            <Combobox.Item>Aardvark</Combobox.Item>
            <Combobox.Item>Cat</Combobox.Item>
            <Combobox.Item>Dog</Combobox.Item>
            <Combobox.Item>Kangaroo</Combobox.Item>
            <Combobox.Item>Panda</Combobox.Item>
            <Combobox.Item>Snake</Combobox.Item>
          </Combobox.Listbox>
        </Combobox.Popover>
      </Combobox>
    </>
  )
}
export default StyledComboboxExample
